import moment from 'moment'

export default (date, format) => moment(date).format(format)